import { createReducer } from '@reduxjs/toolkit'
import { isEqual } from 'lodash'

import types from './types'

export { default as actions } from './actions'

export default createReducer(null, {
  [types.UPDATE_UPCOMING_VISITS]: (state, action) => {
    if (!isEqual(state, action.payload)) {
      return action.payload
    }
    return state
  },
})
